module.exports = __webpack_public_path__ + "static/img/bacs.2cf5ebde.png";